import { isEmpty } from "lodash";

export const createValidatorForNotAdmin = (value: any) => {
  const errors: any = {};

  if (!value.name) {
    errors.name = "Required";
  }

  // if (!value.role) {
  //   errors.role = "Required";
  // }

  // if (!value.phone) {
  //   errors.phone = "Required";
  // }

  return errors;
};

export const createValidator = (value: any) => {
  const errors: any = {};
  console.log("value", value);
  if (!value.name) {
    errors.name = "Required";
  }

  if (!value.role) {
    errors.role = "Required";
  }

  // if (!value.city_code) {
  //   errors.city_code = "Required";
  // }
  // if (!value.province_code) {
  //   errors.province_code = "Required";
  // }

  // if (!value.brgy_code) {
  //   errors.brgy_code = "Required";
  // }

  if (!value.phone) {
    errors.phone = "Required";
  }
  // console.log({ errors });

  return errors;
};

export const createMassUsersValidator = (values: any) => {
  const errors: any = {};

  if (!values.users || !values.users.length) {
    errors.users = { _error: "At least one member must be entered" };
  } else {
    const usersErrors: any[] = [];
    values.users.forEach((user: any, index: number) => {
      const usersError: any = {};

      if (!user || !user.name) {
        usersError.name = "Required";
        usersErrors[index] = usersError;
      }
      // if (!user || !user.role) {
      //   usersError.role = "Required";
      //   usersErrors[index] = usersError;
      // }
      // if (!user || !user.city_code) {
      //   usersError.city_code = "Required";
      //   usersErrors[index] = usersError;
      // }
      // if (!user || !user.phone) {
      //   usersError.phone = "Required";
      //   usersErrors[index] = usersError;
      // }
    });

    if (!isEmpty(usersErrors)) {
      errors.users = usersErrors;
    }
  }
  return errors;
};
